import { _js } from '@ifixit/utils/localize';
import { waitForSelector } from 'Shared/utils/wait-for-selector';
import { YoutubePlayer } from 'Shared/youtube-player';
import introTemplate from 'ejs/embed/embed.v4.intro.ejs';
import Template from 'Shared/template';

export function IntroController(guideData, fullScreenController, prepareEmbed) {
   let template = prepareEmbed(Template.get(introTemplate));
   let element;

   function getElement(guide, isSingle) {
      if (element) {
         element.find('.js-prev').addClass('disabled');
         return element;
      }

      guide.isDangerous = false;
      if (guide.flags.length) {
         $.each(guide.flags, (ndx, flag) => {
            guide.isDangerous = flag.flagid == 'DANGER' || flag.flagid == 'DANGEROUS';
            if (guide.isDangerous) {
               guide.dangerousFlag = flag;
               // Break out of the loop if guide is dangerous
               return false;
            }
         });
      }

      // Only enable featured videos for dozuki sites since we promised video
      // support on launch.
      guide.showIntroVideo = App.siteName !== 'ifixit' && guide.intro_video_url;

      guide.introItemCount = guide.parts.length + guide.tools.length;
      guide.showButtonGroup = guide.introItemCount || guide.documents.length;
      guide.buttonClass = guide.introItemCount && guide.documents.length ? 'button-3' : 'button-2';
      guide.single_step = guide.steps.length === 1;

      guide.pageTitle = _js('Introduction');
      guide.isSingle = isSingle;

      guide.doesLoop = App.videoLooping ? 'loop' : '';

      element = template(guide);
      element.find('.js-prev').addClass('disabled');

      if (!fullScreenController.supported()) {
         element.find('.js-fullscreen').hide();
      }
      element.find('.intro-section-button').click(function (e) {
         clearIntroState();
         $(this).addClass('active');

         clearIntroContent();
         showIntroContent($(this).context.attributes.rendercontent.value);
      });

      return element;
   }

   function clearIntroState() {
      element.find('.intro-section-button').removeClass('active');
   }

   function showIntroContent(renderTarget) {
      element.find('#' + renderTarget).removeClass('hidden');
   }

   function clearIntroContent() {
      element.find('.intro-content').addClass('hidden');
   }

   return {
      getElementImmediately: getElement,
      getElement: function () {
         return guideData
            .get()
            .then(guide => getElement(guide, true))
            .done();
      },
   };
}

waitForSelector(YoutubePlayer.elementClass).then(() => YoutubePlayer.init());
